﻿﻿export interface IProductCenterRequest {
    centerId: number;
    productId: number;
    nextSteps: string;
    targetDate: string;
    closeDate: string;
    closedBy: number;
}
